

import React, { memo, useMemo, useEffect, useState } from 'react';
import _isEmpty from 'lodash.isempty';
import _get from 'lodash.get';
import { FormModal, Text, Dropdown } from '../../../../ui-kit';
















const ArchiveSplashTemplate = (props) => {
  const {
    visible,
    onClose,
    getTemplatesByOrg,
    splashTemplateId,
    updatePitchSplashLink,
    allSplashRelations,
    onArchiveSave
  } = props;
  const [splashTemplates, setSplashTemplates] = useState([]);
  const [newSplashTemplate, setNewSplashTemplate] = useState({});

  const setSplashPagePerOrg = async () => {
    const { data, error } = await getTemplatesByOrg();

    if (!error) {
      setSplashTemplates(data.getSplashPageTemplatesByOrg);
    }
  };

  useEffect(() => {
    setSplashPagePerOrg();
  }, [getTemplatesByOrg]);

  const onSave = async () => {
    await Promise.all(allSplashRelations.map((it) => updatePitchSplashLink({
      pitchTemplateId: it.pitchTemplateId,
      splashTemplateId: newSplashTemplate.templateId
    })));

    await onArchiveSave(splashTemplateId);
    onClose();
  };

  const onSplashPageSelect = ({ value: splashTemplate }) => {
    setNewSplashTemplate(splashTemplate);
  };

  const options = useMemo(() => splashTemplates.map((it) => ({
    value: it,
    label: it.templateName
  })).filter((it) => splashTemplateId !== _get(it, 'value.templateId') &&
  _get(it, 'value.status') === 'PUBLISHED'),
  [splashTemplates]);

  return (
    <FormModal
      key="archive-splash-page-modal"
      title="Archive Splash Page"
      visible={visible}
      onClose={onClose}
      onSave={onSave}
      saveDisabled={_isEmpty(newSplashTemplate)}
      stayOpenOnSave
      saveText="Save">

      <div className="template-action-modal">
        <Text heading5>
          The Splash Page you are trying to archive is referenced by Elevate Templates.
          Please select a Splash Page to replace the current before proceeding.
        </Text>
        <Dropdown
          placeholder="Select Splash Page"
          options={options}
          disabled={false}
          label="Select New Splash Page"
          defaultValue={!_isEmpty(newSplashTemplate) ? newSplashTemplate.templateName : void 0}
          onChange={onSplashPageSelect} />

      </div>
    </FormModal>);

};

export default memo(ArchiveSplashTemplate);